<script>
  import { onMount } from 'svelte';
  import { getApiUrl } from '../api';
  import { Link } from 'svelte-routing';

  let donations = [];
  let totalAmount = 0;
  let page = 1;
  const pageSize = 10;
  let hasMore = false;
  let isLoading = true;

  onMount(fetchDonations);

  async function fetchDonations() {
      isLoading = true;
      try {
          const res = await fetch(getApiUrl(`/donations?page=${page}&pageSize=${pageSize}`));
          const data = await res.json();
          
          if(page === 1) donations = data.data;
          else donations = [...donations, ...data.data];
          
          totalAmount = data.totalAmount;
          hasMore = page < data.totalPages;
      } catch(e) { console.error(e); }
      isLoading = false;
  }
</script>

<div class="list-container">
    <div class="hero">
        <h1>Thank You!</h1>
        <p>Your support keeps SNAP PERK running.</p>
        <div class="total-box">
            <span>Total Raised</span>
            <strong>${totalAmount.toLocaleString(undefined, {minimumFractionDigits: 2, maximumFractionDigits: 2})}</strong>
        </div>
        <Link to="/donate" class="donate-btn">Make a Donation</Link>
    </div>

    <div class="donors-table">
        <h3>Recent Donors</h3>
        <table>
            <thead>
                <tr>
                    <th>Donor</th>
                    <th>Date</th>
                    <th>Amount</th>
                </tr>
            </thead>
            <tbody>
                {#each donations as d}
                    <tr>
                        <td data-label="Donor">
                            <strong>{d.name}</strong>
                            {#if d.message}<br/><em class="msg">"{d.message}"</em>{/if}
                        </td>
                        <td data-label="Date">{new Date(d.createdAt).toLocaleDateString()}</td>
                        <td data-label="Amount" class="amount">{d.currency} {d.amount.toFixed(2)}</td>
                    </tr>
                {/each}
            </tbody>
        </table>
        {#if isLoading}<p class="loading">Loading...</p>{/if}
        {#if hasMore}
            <button on:click={() => {page++; fetchDonations();}} class="load-more">Load More</button>
        {/if}
    </div>
</div>

<style>
    .list-container { max-width: 800px; margin: 2rem auto; text-align: center; padding: 0 1rem; }
    .hero { background: linear-gradient(135deg, #007bff, #0056b3); color: white; padding: 3rem; border-radius: 12px; margin-bottom: 2rem; box-shadow: 0 4px 15px rgba(0,123,255,0.3); }
    .hero h1 { margin: 0; font-size: 2.5rem; }
    .total-box { margin: 2rem 0; font-size: 1.2rem; }
    .total-box strong { display: block; font-size: 2.5rem; margin-top: 0.5rem; text-shadow: 0 2px 4px rgba(0,0,0,0.2); }
    .donate-btn { background: white; color: #007bff; padding: 0.8rem 2rem; border-radius: 30px; text-decoration: none; font-weight: bold; display: inline-block; transition: transform 0.2s; box-shadow: 0 4px 6px rgba(0,0,0,0.1); }
    .donate-btn:hover { transform: scale(1.05); }

    .donors-table { background: white; padding: 1rem; border-radius: 8px; box-shadow: 0 2px 8px rgba(0,0,0,0.05); border: 1px solid #eee; }
    table { width: 100%; border-collapse: collapse; text-align: left; }
    th, td { padding: 1rem; border-bottom: 1px solid #eee; }
    th { color: #666; font-weight: 600; background-color: #f9f9f9; }
    
    .amount { font-weight: bold; color: #28a745; }
    .msg { color: #666; font-size: 0.9rem; display: block; margin-top: 4px; }
    .load-more { margin-top: 1rem; padding: 0.75rem 2rem; border: 1px solid #ddd; background: white; cursor: pointer; border-radius: 4px; font-size: 1rem; transition: background 0.2s; }
    .load-more:hover { background-color: #f1f1f1; }
    .loading { color: #666; margin-top: 1rem; }

    /* Mobile Responsive Table */
    @media (max-width: 768px) {
        .hero { padding: 2rem 1rem; }
        .hero h1 { font-size: 2rem; }
        .total-box strong { font-size: 2rem; }

        thead { display: none; }
        
        table, tbody, tr, td { display: block; width: 100%; box-sizing: border-box; }
        
        tr { margin-bottom: 1rem; border: 1px solid #eee; border-radius: 8px; box-shadow: 0 2px 4px rgba(0,0,0,0.02); }
        
        td { 
            display: flex; 
            justify-content: space-between; 
            align-items: center; 
            text-align: right;
            padding: 0.8rem;
            border-bottom: 1px solid #f9f9f9;
        }
        
        td:last-child { border-bottom: none; }
        
        td::before {
            content: attr(data-label);
            font-weight: 600;
            color: #666;
            text-align: left;
            margin-right: 1rem;
        }
        
        /* Specific tweaks for message alignment */
        td[data-label="Donor"] {
            flex-direction: column;
            align-items: flex-start;
            text-align: left;
        }
        td[data-label="Donor"]::before {
            margin-bottom: 0.2rem;
            font-size: 0.8rem;
            text-transform: uppercase;
            letter-spacing: 0.5px;
        }
    }
</style>